import { render } from "./ParentProductCategoriesDataList.vue?vue&type=template&id=fa52654c&scoped=true"
import script from "./ParentProductCategoriesDataList.vue?vue&type=script&lang=js"
export * from "./ParentProductCategoriesDataList.vue?vue&type=script&lang=js"

import "./ParentProductCategoriesDataList.vue?vue&type=style&index=0&id=fa52654c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa52654c"]])

export default __exports__